import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEarLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 28,
	viewBox: "0 0 18 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5971 15.2031C18.0787 22.4652 18.5505 26.0989 13.0016 26.4669C7.45273 26.8349 0.498233 30.3752 0.0166024 23.1131C-0.465028 15.851 9.18895 0.305695 13.6215 0.0117215C19.1704 -0.356288 17.1154 7.94103 17.5971 15.2031Z",
		fill: "#FFFCD8"
	})
});
export default SvgEarLeft;
